import { default as BaseButtonGroup } from '@mui/joy/ButtonGroup';
import { clsx } from 'clsx';
import { forwardRef } from 'react';
import ButtonGroupButton from './ButtonGroupButton';
import ButtonGroupIconButton from './ButtonGroupIconButton';
import type { ButtonGroupProps } from './types';

const UA_BUTTON_GROUP = 'ua-button-group';

const ButtonGroup = forwardRef<HTMLDivElement, ButtonGroupProps>(function ButtonGroup(props, ref) {
  const { className, disabled, size, ...rest } = props;

  return (
    <BaseButtonGroup
      className={clsx('shadow-xs', UA_BUTTON_GROUP, className)}
      disabled={disabled}
      ref={ref}
      // @ts-expect-error -- size is of same type as ButtonGroupSizes. We are not overriding internal types currently
      size={size}
      {...rest}
    />
  );
});

ButtonGroup.displayName = 'ButtonGroup';

const ButtonGroupNamespace = Object.assign(ButtonGroup, {
  Button: ButtonGroupButton,
  IconButton: ButtonGroupIconButton,
});

export default ButtonGroupNamespace;
